import React from "react";

var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.28 4.473a1.973 1.973 0 0 0-2.817.262L9.614 15.57 5.11 12.506c-.918-.626-2.161-.372-2.773.566s-.364 2.205.555 2.83L10.386 21 21.537 7.347a2.069 2.069 0 0 0-.257-2.874z"
  }));
};

CheckIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
CheckIcon.defaultProps.solid = true;
export default CheckIcon;